export const namespace = 'feathers';